<template lang="pug">
  .text-center.neutral700--text
    redeem-verification-icon
    .text-md.font-semibold.mb-2 Enter verification code
    .text-sm.mb-4 We’ve sent a verification code to the customer. Enter the 4-digit verification code below to redeem the {{ itemText }}.
    .otp-container
      v-otp-input(length="4" :value="value" type="number" @input="$emit('input', $event)")
</template>

<script>
import RedeemVerificationIcon from "@/components/clinic/checkout/marketing/redeem/RedeemVerificationIcon.vue";

export default {
  components: {
    RedeemVerificationIcon,
  },
  props: {
    value: {
      type: String,
      default: null
    },
    itemText: {
      type: String,
      default: 'offer'
    }
  },
}
</script>

<style scoped>
.otp-container {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
</style>